import React, { useEffect, useState } from 'react';
import { ButtonGroup, Button } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from "react-icons/fa";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getCorrInfra } from '../../../redux/actions/infraactions';
import { PDFViewer } from '@react-pdf/renderer';
import './MtoInfraPDF.css';
import MtoCorrInfraDocuPDF from './MtoCorrInfraDocuPDF';


const MtoCorrPDF = ({ getCorrInfra, datainfra, match }) => {
  
  const [verPDF, setVerPDF] = useState(false);
  const history = useHistory();

  const { mtocorrectivoinfra, loadingmto } = datainfra;

  useEffect(() => {
    // get MTO PREVENTIVO DEBE ENVIAR DESDE LA LISTA EL ID DEL REPORTE DE MTO TAMBIÉN
    getCorrInfra(match.params.areaId,match.params.clienteId,match.params.mtoId);
    
  }, [getCorrInfra, match.params.areaId,match.params.clienteId,match.params.mtoId]);

  const handleOpenPDF = () => {
    setVerPDF(!verPDF);
    
  };

  const goBack = () => {
    history.goBack(); // Esto llevará a la página anterior, independientemente de su origen.
  };

   // Función que renderiza el contenido central según el estado
    const renderContent = () => {
      // 1) Validar si NO hay plantillaType
      if (!mtocorrectivoinfra.cliente?.plantillaType) {
        return (
          <div className="mto-error-message">
            <p>
              Para ver el PDF, primero debe configurar el tipo de plantilla 
              (plantillaType) en la información del cliente.
            </p>
          </div>
        );
      }
  
      // 2) Si tenemos datos y se presiona "Ver PDF"
      //    asumiendo que en mtoinfra viene algo como: 
      //    { area: { ... }, cliente: { ... }, mto: { ... } }
      if (mtocorrectivoinfra?.area && mtocorrectivoinfra?.cliente && mtocorrectivoinfra?.mto && mtocorrectivoinfra.solicitud && verPDF) {
        return (
          <PDFViewer style={{ width: "100%", height: "90vh" }}>
            <MtoCorrInfraDocuPDF
              area={mtocorrectivoinfra.area}
              cliente={mtocorrectivoinfra.cliente}
              mto={mtocorrectivoinfra.mto}
              solicitud={mtocorrectivoinfra.solicitud}
            />
          </PDFViewer>
        );
      }
  
      return null;
    };

  return (
    <div className='div-inventaripdfgeneral'>
      <div className='div-inventaripdftitulo'>
        <div className="div_boton">
          <MyButton tip="Volver" onClick={goBack}>
            <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
          </MyButton>
        </div>
         {/* 
                 Solo mostramos el botón "Ver PDF" si el cliente tiene plantillaType. 
                 De lo contrario, mostramos el mensaje de error en renderContent().
               */}
               {mtocorrectivoinfra.cliente?.plantillaType && (
                 <Button 
                   variant="text"
                   color="primary"
                   onClick={handleOpenPDF}
                 >
                   {verPDF ? "Ocultar PDF" : "Ver PDF"}
                 </Button>
               )}
      </div>
      <div className='div-inventariopdfcontent'>
      {renderContent()}
      </div>
    </div>
  );
}

MtoCorrPDF.propTypes = {
    getCorrInfra: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  datainfra: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
  data: state.data,
  datainfra:state.datainfra
})

export default connect(mapStateToProps, { getCorrInfra})(MtoCorrPDF);
